import { Action } from "../actions/types"
import { StopMasterType, StopMasterActionList } from "../actions/stopMasterActions"

const initialValue: Array<StopMasterType> = []

const stopMasterReducer = (state: Array<StopMasterType> = initialValue, action: Action) => {
    switch (action.type) {

        case StopMasterActionList.ADD_STOP_MASTER:
            return [
                ...state,
                action.data,
            ]

        case StopMasterActionList.UPDATE_STOP_MASTER:
            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated

        case StopMasterActionList.FETCH_STOP_MASTER:
            return action.data

        case StopMasterActionList.DELETE_STOP_MASTER:
            return state.filter(s => s.id !== action.data)

        default:
            return state
    }
}

export default stopMasterReducer